<template>
  <form-field
    :id="id"
    :title="title"
    :error-message="errorMessage"
    :block-label="true"
    :mandatory="mandatory"
    :data-qa="dataQa"
  >
    <div v-for="opt in options" :key="opt.value" class="radio-toggle__option">
      <input
        :id="`${id}_${opt.value}`"
        v-model="selectedOption"
        :value="opt.value"
        type="radio"
        :name="`options_${id}`"
        :disabled="disabled || disabledOptions.includes(opt) || null"
        autocomplete="off"
        :data-qa="dataQa"
        @change="$emit('change', $event.target.value)"
      />
      <label :for="`${id}_${opt.value}`" :data-qa="`${dataQa}_label`">
        {{ opt.name || opt.value }}
      </label>
    </div>
  </form-field>
</template>

<script>
import FormField from '@/components/generic/presentational/atoms/formField/FormField.vue'

export default {
  components: {
    FormField,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
    dataQa: {
      type: String,
      default: null,
    },
    disabledOptions: {
      type: Array,
      default() {
        return []
      },
    },
  },
  emits: ['change'],
  data() {
    return {
      selectedOption: null,
    }
  },
  mounted() {
    this.selectedOption =
      this.modelValue || (this.options.find((x) => x.default) || this.options[0])?.value
  },
}
</script>

<style lang="scss" scoped>
.radio-toggle {
  &__option {
    display: inline-block;
    margin-right: 0.5rem;
    &:last-child {
      margin-right: 0;
    }
  }
}

input[type='radio'] {
  display: none;

  & + label {
    cursor: pointer;
    display: inline-block;
    padding: 0.5em 1em;
    line-height: 1.125;
    text-align: center;
    margin-bottom: 0.25em;
    border: 2px solid $gray-dark;
    color: $gray-dark;
  }

  &[disabled] + label {
    border: 2px solid $gray;
    color: $gray;
    cursor: default;
  }

  &:checked + label {
    border-color: $color-primary;
    color: $color-primary;
    font-weight: $font-weight-bold;
  }
}
</style>
